var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pr-wrapper',{staticClass:"flex-column align-items-center justify-content-center h-100",attrs:{"id":"splash","fs":"","bg":"","zi":"998"}},[_c('img',{attrs:{"src":require("@/assets/images/software.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }